/* eslint-disable no-unused-vars */
import React from 'react';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';
import { useHistory } from 'react-router-dom';
import Container from '@material-ui/core/Container';
import Header from './Header';
import Footer from './Footer';


const useStyles = makeStyles((theme) => ({
  section: {
    [theme.breakpoints.down('md')]: {
      textAlign: 'center',
      backgroundSize: 'cover',
    },
    textAlign:'center',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundRepeat: 'no-repeat',
    backgroundSize: '100% 100%',
    backgroundPosition: 'center',
    margin:'auto'
  },
  btn: {
    color: 'white',
    borderRadius: '5px',
    backgroundColor: '#0046AD',
    width: '15%',
    padding: '5px',
    border: '2px solid transparent',
    marginRight: '3rem',
    '&:hover': {
      color: 'white',
      borderRadius: '5px',
      backgroundColor: '#0046AD',
    },
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      marginBottom: '1rem',

    }
  },
  heading:{
    //fontSize:'32px',
    color:'#0046AD',
    //[theme.breakpoints.down('sm')]:{
      //fontSize:'22px'
    //}
  },
  subtitle:{
    fontSize:'24px',
    color:'#0046AD',
    fontWeight:'bold',
    [theme.breakpoints.down('sm')]:{
      fontSize:'18px'
    }
  },
  content:{
    fontSize:'20px',
    textAlign:'left',
    lineHeight:'40px',
    [theme.breakpoints.down('sm')]:{
      fontSize:'16px',
      lineHeight:'30px',
    }
  }

}));

export default function AboutPage(): JSX.Element {
  const styles = useStyles();
  const history =useHistory();
  return (
    <>
      <Header />
      <Container maxWidth={false}>
      <p>&nbsp; </p>
      <Grid item xs={1} md={2}> </Grid>
            
          <Grid  item className={styles.section} style={{
            // columnGap: '4%',
            paddingTop: '10%',
            paddingBottom: '5%',color:'#333333'
          }} xs={10} md={8}>
             <h1 className={styles.heading}>About</h1>
            <Grid item  style={{textAlign:'left'}}>
             <p className={styles.subtitle}>NURTURING THE SEED OVERVIEW</p>
            
             <p className={styles.content}>
              Nurturing the Seed (NTS) is an innovative infant and early mental health program that aims to support and strengthen the well-being of Indigenous children, parents/caregivers, and communities. NTS fosters local leadership, supports front-line service providers, and responds to the needs of families by providing tools, coaching, and resources specific to the health and development of infants and children (ages 0-5). NTS utilizes developmental screening and culturally relevant, relationship-focused planning to support optimal development in young children. 
              Created in 2019, the NTS model was co-designed by IEMHP in partnership with Indigenous Elders and experts to incorporate and reflect cultural practices and values. It was developed to address the challenges many families face in accessing timely and appropriate services and supports needed when developmental concerns arise. NTS offers responsive, simple, tangible strategies for families to incorporate into their daily lives immediately while waiting for specialized services that often have long waitlists.  
            </p> 
 <p className={styles.content}>
  NTS is an inclusive and flexible program that can be adapted by agencies based on their community's unique needs and service delivery models. The NTS philosophy is rooted in three key concepts: (1) the first 5 years of life are crucial for a child's development, (2) parents and caregivers are the experts in their child's life, and (3) early developmental screening using tools such as the <a href="https://agesandstages.com/" target='_blank'>Ages and Stages Questionnaires (ASQs)</a> is vital.
 </p>
             </Grid>
             <Grid item  style={{textAlign:'left',marginTop:'55px'}}>
             <p className={styles.subtitle}>DEVELOPMENTAL SUPPORT PLANS</p>
            
             <p className={styles.content}>
             The program utilizes customizable <a href='https://sickkids.b-cdn.net/medialibrary/00000000-0000-0000-0000-000000000000/c5d6be5b-8db9-4184-a374-606b5d705b86/1/c5d6be5b-8db9-4184-a374-606b5d705b86.pdf' target='_blank'>Developmental Support Plans (DSPs)</a> to help nurture healthy development in the five domains (communication, gross motor, fine motor, problem solving, social-emotional) through everyday activities and positive routines, fostering self-esteem and resilience.
             </p>  
              <p className={styles.content}>
                For the creation of DSPs, service providers utilize the NTS web app. The app is based on the five domains, subdividing them into categories and then objectives to make it easy for service providers and caregivers to select goals to work on with the child. To help achieve each goal, the NTS app is strength-based and written in the voice of the child: beginning with “What I can already do”, followed by a database of strategies (activities/routines) to choose from, and concluding with the benefit or “Why this is important to me”.
              </p>
             </Grid>

             <Grid item  style={{textAlign:'left',marginTop:'55px'}}>
             <p className={styles.subtitle}>PARTNERS</p>
            
             <p className={styles.content}>&#x2022; Nishnawbe Aski Nation</p> 
             <p className={styles.content}>&#x2022; Public Health Agency of Canada</p> 
             <p className={styles.content}>&#x2022; University of Ottawa</p> 
             <p className={styles.content}>&#x2022; University of Calgary</p> 
             <p className={styles.content}>&#x2022; Queen's University</p> 
             
             </Grid>
 <Grid item  style={{textAlign:'left',marginTop:'55px'}}>
             <p className={styles.subtitle}>CONTACT</p>
             <p className={styles.content}>For general inquiries or technical support, please contact <a href='mailto:iemhp.mail@comms.sickkids.ca' target='_bland'>iemhp.mail@comms.sickkids.ca</a>. </p>
             <p className={styles.content}>For more information, please visit <a href='https://www.iemhp.ca/nts' target='_blank'> our NTS page</a>.</p>
             </Grid>
           {/* <Grid style={{textAlign:'left',marginTop:'55px'}}>
                <p style={{fontSize:'28px',color:'#0046AD'}}>Are you interested in joining NtS Study? </p>
                <Button variant="contained" className={styles.btn} onClick={() => history.push('/contact')} >
                    Contact Us
                </Button>
            </Grid>*/}
             
        </Grid>

        <Grid item xs={1} md={2}> </Grid>
      </Container>
      <Footer />
    </>
  );
}